import { SVGProps, useId } from "react";

export default function TicketStarIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M13.8721 3.71704C15.5626 3.71706 16.4928 3.98332 17.0283 4.5188C17.5638 5.0543 17.83 5.98451 17.8301 7.67505V12.3254C17.8301 14.0161 17.5639 14.9471 17.0283 15.4827C16.4927 16.0179 15.5622 16.2834 13.8721 16.2834H8.75488V14.2668C8.75481 13.8539 8.51673 13.4912 8.17188 13.3088V6.69067C8.51651 6.50817 8.75488 6.14646 8.75488 5.73364V3.71704H13.8721Z"
        stroke={`url(#paint0_${id})`}
      />
      <path
        d="M13.0176 8.06665C13.0184 8.06665 13.0197 8.06716 13.0215 8.06763C13.0235 8.06819 13.0261 8.06881 13.0273 8.06958V8.07056L13.502 9.03735L13.5039 9.04028C13.5959 9.22418 13.766 9.33753 13.9443 9.37329L13.957 9.37622L13.9688 9.37817L15.0361 9.53638L15.0469 9.53735H15.0479L15.0498 9.54321L15.0488 9.552L15.043 9.55884L14.2852 10.301L14.2568 10.3274L14.2344 10.3586C14.165 10.4512 14.0678 10.6312 14.1084 10.8596V10.8606L14.291 11.9143V11.9231C14.2909 11.9241 14.2905 11.925 14.29 11.926C14.2891 11.9284 14.2866 11.9333 14.2793 11.9387C14.2758 11.9413 14.2735 11.9416 14.2725 11.9417C14.2715 11.9417 14.2697 11.9422 14.2666 11.9407L14.2656 11.9397L13.3076 11.4397L13.2998 11.4358L13.2246 11.4045C13.1502 11.3792 13.0783 11.3704 13.0176 11.3704C12.9367 11.3704 12.8356 11.3857 12.7354 11.4358L12.7275 11.4397L11.7695 11.9397L11.7666 11.9407L11.7598 11.9417H11.7588C11.7574 11.9408 11.7554 11.9395 11.7529 11.9377L11.7432 11.9299V11.927L11.9268 10.8684L11.9258 10.8674C11.9476 10.7415 11.9466 10.4915 11.7471 10.3079L11.749 10.3069L10.9736 9.55688L10.9688 9.55298L10.9697 9.54224C10.9705 9.5413 10.9724 9.54035 10.9736 9.53931C10.975 9.53819 10.9758 9.53678 10.9766 9.53638H10.9824L12.0488 9.3772C12.2424 9.35332 12.428 9.23571 12.5225 9.03638L12.5244 9.03735L12.9941 8.08228C12.9984 8.07413 13.0021 8.07072 13.0039 8.06958C13.0049 8.06898 13.0063 8.06809 13.0078 8.06763C13.0095 8.06715 13.0129 8.06666 13.0176 8.06665Z"
        stroke={`url(#paint1_${id})`}
      />
      <path
        d="M6.12305 3.71704H6.58887V5.73364C6.58887 6.15483 6.82928 6.51282 7.17285 6.69263V13.3079C6.82766 13.4901 6.58894 13.8537 6.58887 14.2668V16.2834H6.12305C4.49694 16.2834 3.57126 16.0341 3.02734 15.5393C2.49412 15.0543 2.20961 14.2227 2.17285 12.7219L2.17188 12.7073C2.17186 12.7065 2.17224 12.7028 2.1748 12.6965C2.17793 12.6892 2.18327 12.6793 2.19238 12.6702L2.19922 12.6643L2.20605 12.6575C2.20683 12.6568 2.21043 12.6525 2.21973 12.6487C2.23102 12.6441 2.2444 12.6419 2.25586 12.6418C3.69983 12.6418 4.88068 11.4588 4.88086 10.009C4.88086 8.56171 3.70247 7.36743 2.25586 7.36743C2.23181 7.36743 2.22131 7.36263 2.21875 7.36157C2.21704 7.36086 2.2132 7.35946 2.20605 7.35181L2.19238 7.33813C2.19012 7.33582 2.18681 7.33227 2.18359 7.32739C2.18033 7.32242 2.17791 7.31691 2.17578 7.31177C2.17095 7.29986 2.17225 7.29584 2.17188 7.30298V7.29517L2.17285 7.28735C2.20959 5.78202 2.49497 4.94917 3.02832 4.46313C3.57216 3.96762 4.4969 3.71704 6.12305 3.71704Z"
        fill={`url(#paint2_${id})`}
        stroke={`url(#paint3_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_${id}`}
          x1="13.001"
          y1="3.21704"
          x2="13.001"
          y2="16.7837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint1_${id}`}
          x1="13.0093"
          y1="7.56665"
          x2="13.0093"
          y2="12.4421"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint2_${id}`}
          x1="4.67223"
          y1="3.21704"
          x2="4.67223"
          y2="16.7837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint3_${id}`}
          x1="4.67223"
          y1="3.21704"
          x2="4.67223"
          y2="16.7837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
